import React, { useEffect, useState } from "react";
import Menu from "./Menu/Menu";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import Error from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import SymbolCard from "./SymbolCard";
import moment from "moment";
import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function SymbolRejection() {
  const [play] = useSound(Error);
  const windowSize = useSize();

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = (a, b) => {
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      start: a ?? moment().startOf("week"),
      end: b ?? moment().endOf("week"),
    };

    backend.symbol_rejection(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setLogs(r.rejection);
      } else {
        play();
        toast.error(r.message);
      }
    });
  };

  return (
    <div className="w-full">
      <Filter records={logs.length} loadLogs={loadLogs} logs={logs} />
      <Menu />

      {/* Container */}
      <div
        key={logs}
        className="flex flex-col"
        style={{ height: windowSize[1] - 190 }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 190} />
          </div>
        ) : logs.length > 0 ? (
          /* Scroll area */
          <div
            className="overflow-y-scroll w-full"
            style={{ height: windowSize[1] - 190 }}
          >
            {logs.map((item) => (
              <SymbolCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 190}
            title="Nothing here"
            subtext="No Symbol Logs Found."
          />
        )}
      </div>
    </div>
  );
}
